"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.localesQueryDtoSchema = exports.AudioMessageKeyEnum = void 0;
const zod_1 = require("zod");
var AudioMessageKeyEnum;
(function (AudioMessageKeyEnum) {
    AudioMessageKeyEnum["WELCOME"] = "welcomeMessage";
    AudioMessageKeyEnum["FEEDBACK_CATEGORIES_INTRO"] = "feedback_categories_intro";
    AudioMessageKeyEnum["FEEDBACK_LANGUAGE_CHANGED"] = "feedback_language_changed";
    AudioMessageKeyEnum["FEEDBACK_CATEGORY_CONFIRM"] = "feedback_category_confirm";
    AudioMessageKeyEnum["FEEDBACK_RECORD_RULES"] = "feedback_record_rules";
    AudioMessageKeyEnum["FEEDBACK_RECORDING_ACTIVE"] = "feedback_recording_active";
    AudioMessageKeyEnum["FEEDBACK_RECORDING_ENDING"] = "feedback_recording_ending";
    AudioMessageKeyEnum["FEEDBACK_CLIP_SAVED"] = "feedback_clip_saved";
    AudioMessageKeyEnum["FEEDBACK_RECORD_SILENCE"] = "feedback_record_silence";
    AudioMessageKeyEnum["FEEDBACK_MIC_UNAVAILABLE"] = "feedback_mic_unavailable";
    AudioMessageKeyEnum["FEEDBACK_CLIP_DELETE_CONFIRM"] = "feedback_clip_delete_confirm";
    AudioMessageKeyEnum["FEEDBACK_READY_TO_SEND"] = "feedback_ready_to_send";
    AudioMessageKeyEnum["FEEDBACK_QUEUED_OFFLINE"] = "feedback_queued_offline";
    AudioMessageKeyEnum["FEEDBACK_SENT_ONLINE"] = "feedback_sent_online";
    AudioMessageKeyEnum["FEEDBACK_SENT_AFTER_SYNC"] = "feedback_sent_after_sync";
})(AudioMessageKeyEnum || (exports.AudioMessageKeyEnum = AudioMessageKeyEnum = {}));
exports.localesQueryDtoSchema = zod_1.z.object({
    page: zod_1.z.coerce.number().int().positive().default(1).optional(),
    limit: zod_1.z.coerce.number().int().positive().max(100).default(10).optional(),
});
